import {
  Box,
  Button,
  FormControl,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  PROXY_FAC_URL,
  PROXY_ORG_URL,
  PROXY_ROLE_URL,
} from "../../constants/url.constants";
import { useDispatch, useSelector } from "react-redux";
import { fetchOptionsGet } from "../../services/list.service";
import { clearProxy, executeProxy } from "../../actions/auth";
import { PROXY_FAC, PROXY_ORG, PROXY_ROLE } from "../../actions/type";
import { useNavigate } from "react-router-dom";
import { isEmptyString } from "../../util/util";
import { ResponsiveRow } from "../../constants/layout.constants";
import MUIAutoCompleteForm from "../inputs/MUIautoCompleteForm";

export default function AdminProxyBar() {
  const user = useSelector((state) => state.auth.user);
  const [roleList, setRoleList] = useState([]);
  const [facilityList, setFacilityList] = useState([]);
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [selectedRole, setSelectedRole] = useState({
    label: "--",
    value: "--",
  });
  const [selectedFacility, setSelectedFacility] = useState({
    label: "--",
    value: "--",
  });
  const [selectedSubscription, setSelectedSubscription] = useState({
    label: "--",
    value: "--",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    fetchOptionsGet(PROXY_ROLE_URL).then((data) => {
      if (data) {
        setRoleList(data);
      }
    });
    fetchOptionsGet(PROXY_ORG_URL).then((data) => {
      if (data) {
        setSubscriptionList(data);
      }
    });
    fetchOptionsGet(PROXY_FAC_URL).then((data) => {
      if (data) {
        setFacilityList(data);
      }
    });
  }, []);

  useEffect(() => {
    if (user.proxySubscription !== "") {
      subscriptionList.forEach((item) => {
        if (String(item.value).includes(user.proxySubscription)) {
          setSelectedSubscription(item);
        }
      });
    } else {
      setSelectedSubscription({
        label: "--",
        value: "--",
      });
    }
  }, [user, selectedFacility, subscriptionList]);

  useEffect(() => {
    if (user.proxyFacility !== "") {
      facilityList.forEach((item) => {
        if (String(item.value).includes(user.proxyFacility)) {
          setSelectedFacility(item);
        }
      });
    } else {
      setSelectedFacility({
        label: "--",
        value: "--",
      });
    }
  }, [user, facilityList]);

  useEffect(() => {
    if (user.proxyRole !== "") {
      roleList.forEach((item) => {
        if (String(item.value).includes(user.proxyRole)) {
          setSelectedRole(item);
        }
      });
    } else {
      setSelectedRole({
        label: "--",
        value: "--",
      });
    }
  }, [user, roleList])

  useEffect(() => {
    dispatch(
      executeProxy(user.proxyRole, user.proxySubscription, user.proxyFacility)
    );
    if (!isEmptyString(user.proxySubscription)) {
      fetchOptionsGet(
          PROXY_FAC_URL + "?subscriptionId=" + user.proxySubscription
      ).then((data) => {
        if (data) {
          setFacilityList(data);
        }
      });
    } else {
      fetchOptionsGet(PROXY_FAC_URL).then((data) => {
        if (data) {
          setFacilityList(data);
        }
      });
    }
  }, [user?.proxyRole, user?.proxySubscription, user?.proxyFacility, dispatch]);

  const handleRoleChange = (selection) => {
    if(selection) {
      dispatch({
        type: PROXY_ROLE,
        payload: selection.value,
      });
    }
    setSelectedRole(selection);
  };

  const handleFacilityChange = (selection) => {
    if (selection) {
      dispatch({
        type: PROXY_FAC,
        payload: selection.value,
      });
    }
    setSelectedFacility(selection);
  };

  const handleSubscriptionChange = (selection) => {
    if (selection) {
      if (selectedRole.value !== "") {
        dispatch({
          type: PROXY_ROLE,
          payload: selectedRole.value,
        });
      }
      dispatch({
        type: PROXY_ORG,
        payload: selection.value,
      });
    }
    setSelectedSubscription(selection);
  };

  const handleClearProxy = () => {
    setSelectedSubscription({
      label: "--",
      value: "--",
    });
    setSelectedFacility({
      label: "--",
      value: "--",
    });
    setSelectedRole({
      label: "--",
      value: "--",
    })
    dispatch(clearProxy());
    navigate("/dashboard");
  };

  return (
    <Grid
      container
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignContent: "center",
        width: { xs: "100%", md: "80%" },
        backgroundColor: "white",
        padding: "1vh",
        borderRadius: "1vh",
        margin: "20px auto",
        boxShadow: "0 4px 5px 0 rgba(0,0,0,0.5)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { lg: "row", xs: "column" },
          justifyContent: { md: "space-between", xs: "center" },
          width: "100%",
        }}
        component="form"
      >
        <ResponsiveRow
          sx={{
            flexDirection: { md: "row", xs: "column" },
            flexWrap: { md: "wrap", lg: "nowrap" },
            gap: "2px",
            justifyContent: "space-between",
            width: { md: "100%", lg: "75%" },
          }}
        >
          <FormControl
            sx={{
              margin: { lg: "auto 20px", xs: "10px auto " },
              width: {
                md: "33%",
                xs: "100%",
              },
            }}
          >
            <MUIAutoCompleteForm
                itemsData={roleList}
                label="Role"
                updateSelected={handleRoleChange}
                currentlySelected={selectedRole}
                menuId="roleSelector"
                width="100%"
                maxListHeight={"300px"}
                disableClearable={true}
                emptyMessage="No roles to show"
                inputFullWidth={true}
            />
          </FormControl>

          <FormControl
            sx={{
              margin: { lg: "auto 20px", xs: "10px auto " },
              width: {
                md: "33%",
                xs: "100%",
              },
            }}
          >
            <MUIAutoCompleteForm
              itemsData={subscriptionList}
              label="Subscription"
              updateSelected={handleSubscriptionChange}
              currentlySelected={selectedSubscription}
              menuId="subscriptionSelector"
              width="100%"
              disableClearable={true}
              emptyMessage="No subscriptions to show"
              inputFullWidth={true}
            />
          </FormControl>

          <FormControl
            sx={{
              margin: { lg: "auto 20px", xs: "10px auto " },
              width: { md: "33%", xs: "100%" },
            }}
          >
            {facilityList && (
              <MUIAutoCompleteForm
                itemsData={facilityList}
                label="Facility"
                updateSelected={handleFacilityChange}
                currentlySelected={selectedFacility}
                menuId="facilitySelector"
                width="100%"
                disableClearable={true}
                emptyMessage="No facilities to show."
                inputFullWidth={true}
              />
            )}
          </FormControl>
        </ResponsiveRow>

        <Button
          sx={{
            width: { xs: "100%", lg: "200px" },
            height: "60px",
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            backgroundColor: "#E53935",
            color: "#fff",
            margin: { lg: "auto 10px", xs: "auto" },
          }}
          fullWidth
          onClick={handleClearProxy}
        >
          <Typography
            sx={{
              color: "#fff",
              width: "100%",
              fontWeight: "medium",
            }}
            variant="body2"
          >
            Clear Proxy
          </Typography>
        </Button>
      </Box>
    </Grid>
  );
}
